import MapHandler from '../mapHandler';

export default class Activity extends MapHandler {
  constructor(options = {}) {
    super(options);
  }
}
